const TabTableSkeleton = () => (
  <div className="space-y-3 animate-pulse">
    <div className="h-10 rounded-lg bg-neutral-100 w-full" />
    {Array.from({ length: 6 }).map((_, i) => (
      <div
        key={i}
        className="h-14 rounded-lg bg-neutral-50 border border-neutral-100"
      />
    ))}
  </div>
)

export default TabTableSkeleton
